import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function ServiceHighlights() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
            Our Services
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            核心服务
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            三大核心业务模块，全方位满足你对医护美学的所有想象
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category?tab=${cat.slug}`}
              className="group relative bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-lg bg-white/90 text-primary-500">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  了解更多
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}